import { Table } from "antd"
import { Link } from "react-router-dom"
import { ColumnType } from "antd/es/table"

import { EventBase } from "../api.types"
import { useFetch } from "../hooks/useFetch"
import { useDateFormat } from "../hooks/useDateFormat"

export enum EventStatus {
    Propositions = "propositions",
    PropositionsWait = "propositions-wait",
    Preferences = "preferences",
    PreferencesWait = "preferences-wait",
    Done = "done",
}

export function EventList(props: {}) {
    const events = useFetch<EventBase[]>("/api/events");
    const formatDate = useDateFormat()

    const columns: ColumnType<any>[] = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id"
        },
        {
            title: "Nazwa",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Data",
            dataIndex: "date",
            key: "date"
        },
        {
            title: "Link",
            dataIndex: "link",
            key: "link"
        }
    ]

    const data = events === undefined ? [] :
        events.map((e) => {
            return {
                key: e.id,
                id: e.id,
                name: e.name,
                date: formatDate(e.eventDate),
                link: <Link to={"/event/" + e.id}>Link</Link>
            }
        })

    return <Table
        columns={columns}
        dataSource={data || []}
        loading={data === undefined}
    />
}
